export { default as DisabledReport } from 'reports/containers/DisabledReportContainer';
export { default as EmployeesAssetsReport } from 'reports/containers/EmployeesAssetsReportContainer';
export { default as HistoricsReport } from 'reports/containers/HistoricsReportContainer';

export { default as InsOutsReport } from 'reports/containers/InsOutsReportContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/index.js